import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { featuresActions } from '../../../store';
import { getJsonFromSheet } from '../../../Helpers/SheetsHelper';
import { sharedActions } from '../../../store';
import styles from './PaintPackages.module.css';
import PackageCard from '../PackageCard/PackageCard';


export default function PaintPackages() {
    const dispatch = useDispatch();
    const selectedPaintPackage = useSelector(state => state.features.selectedPaintPackage);
    const colorSeriesData = useSelector(state => state.shared.seriesData)[9699];
    const [packages, setPackages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const loadPackages = async () => {
            try {
                setLoading(true);
                // Load Excel file from public data folder
                const data = await getJsonFromSheet('/data/paint_packages.xlsx', 'Sheet1');
                
                if (!data || data.length === 0) {
                    throw new Error('No data found in Excel file');
                }

                // Transform the data into a cleaner format
                const transformedPackages = data.map(row => ({
                    schemeNumber: row['Scheme #'],
                    body: row['Body'],
                    bodyProductId: row['BodyProductId'],
                    secondaryBody: row['Secondary Body'],
                    secondaryProductId: row['SecondaryProductId'],
                    trim: row['Trim'],
                    trimProductId: row['TrimProductId'],
                    accent1: row['Accent1'],
                    accent1ProductId: row['Accent1ProductId'],
                    accent2: row['Accent2'],
                    accent2ProductId: row['Accent2ProductId']
                }));

                setPackages(transformedPackages);
                setError(null);
            } catch (err) {
                console.error('Error loading paint packages:', err);
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        loadPackages();
    }, []);

    const handlePackageSelect = (pkg) => {
        dispatch(featuresActions.setSelectedPaintPackage(pkg));
        console.log('Package selected:', pkg);

        document.getElementById('chamViz').applyByFilter("", "", function (newSel, currentSelectedSurface) {
            if(this.name == 'Body'){
                dispatch(sharedActions.setVizLoading(true));
                dispatch(featuresActions.setAppliedProduct({
                    tab: 'exterior',
                    surface: 'Walls',
                    product: colorSeriesData[pkg.bodyProductId]
                }));
                return pkg.bodyProductId
            }

            if(this.name == 'Secondary Body'){
                dispatch(sharedActions.setVizLoading(true));
                dispatch(featuresActions.setAppliedProduct({
                    tab: 'exterior',
                    surface: 'Secondary Body',
                    product: colorSeriesData[pkg.secondaryProductId]
                }));
                return pkg.secondaryProductId
            }
            

            if(this.name == 'Trim'){
                dispatch(sharedActions.setVizLoading(true));
                dispatch(featuresActions.setAppliedProduct({
                    tab: 'exterior',
                    surface: 'Trim',
                    product: colorSeriesData[pkg.trimProductId]
                }));
                return pkg.trimProductId
            }


        },true);

    };

    if (loading) {
        return <div className={styles.message}>Loading paint packages...</div>;
    }

    if (error) {
        return <div className={styles.errorMessage}>Error: {error}</div>;
    }

    return (
        <div className={styles.paintPackages}>
            <div className={styles.packagesGrid}>
                {packages.map((pkg) => (
                    <PackageCard 
                        key={pkg.schemeNumber} 
                        package={pkg} 
                        isSelected={selectedPaintPackage?.schemeNumber === pkg.schemeNumber}
                        onSelect={handlePackageSelect}
                    />
                ))}
            </div>
        </div>
    );
}
